import React from 'react'
import { Alert } from 'react-bootstrap'
import { Link } from 'react-router'

import { ROUTES } from '../../../../../lib/routes'
import MeetingLink from './components/MeetingLink'

interface Props {
  onUpdate?: () => void
}

const Scheduling: React.FC<Props> = ({ onUpdate }) => {
  return (
    <>
      <MeetingLink onUpdate={onUpdate} />

      <Alert
        className="d-flex flex-column align-items-center p-3"
        variant="light"
      >
        <p className="text-center pb-0">
          Or you can connect your own calendar account, to enable scheduling
          directly through RQ.{' '}
          <Link to={ROUTES.emailAndCalendarIntegration}>Learn more</Link>.
        </p>
      </Alert>
    </>
  )
}

export default Scheduling
